import React from 'react';

const Hero: React.FC = () => {
  return (
    <>
      {/* Desktop Hero - exact Figma layout */}
      <section className="hidden desktop:block bg-background-secondary w-full">
        <div className="w-device-desktop mx-auto px-600 py-4000 flex flex-col gap-800 items-center">
          {/* Text Content Title */}
          <div className="flex flex-col gap-200 items-center text-center">
            <h1 className="text-[72px] font-bold text-text-default leading-[1.2] whitespace-pre-wrap w-full">
              Title
            </h1>
            <div className="flex flex-col justify-center leading-[0] w-full">
              <p className="text-[32px] font-regular text-text-secondary leading-[1.2] whitespace-pre-wrap">
                Subtitle
              </p>
            </div>
          </div>
          
          {/* Button Group */}
          <div className="flex gap-400 items-center w-[240px]">
            <button className="flex-1 min-h-0 min-w-0 bg-background-neutral-tertiary border border-border-neutral-secondary rounded-200 hover:bg-opacity-90 transition-all">
              <div className="flex gap-200 items-center justify-center px-300 py-300 w-full">
                <span className="text-text-default text-[16px] leading-none font-regular">Button</span>
              </div>
            </button>
            <button className="flex-1 min-h-0 min-w-0 bg-background-brand-default border border-border-brand-default rounded-200 hover:bg-opacity-90 transition-all">
              <div className="flex gap-200 items-center justify-center px-300 py-300 w-full">
                <span className="text-text-brand-on-brand text-[16px] leading-none font-regular">Button</span>
              </div>
            </button>
          </div>
        </div>
      </section>

      {/* Mobile Hero - exact Figma layout */}
      <section className="block desktop:hidden bg-background-secondary w-full">
        <div className="px-400 py-4000 flex flex-col gap-800 items-center">
          {/* Text Content Title */}
          <div className="flex flex-col gap-200 items-center text-center">
            <h1 className="text-[48px] font-bold text-text-default leading-[1.2] whitespace-pre-wrap w-full">
              Title
            </h1>
            <div className="flex flex-col justify-center leading-[0] w-full">
              <p className="text-[32px] font-regular text-text-secondary leading-[1.2] whitespace-pre-wrap">
                Subtitle
              </p>
            </div>
          </div>
          
          {/* Button Group */}
          <div className="flex gap-400 items-center w-[240px]">
            <button className="flex-1 min-h-0 min-w-0 bg-background-neutral-tertiary border border-border-neutral-secondary rounded-200 hover:bg-opacity-90 transition-all">
              <div className="flex gap-200 items-center justify-center px-300 py-300 w-full">
                <span className="text-text-default text-[16px] leading-none font-regular">Button</span>
              </div>
            </button>
            <button className="flex-1 min-h-0 min-w-0 bg-background-brand-default border border-border-brand-default rounded-200 hover:bg-opacity-90 transition-all">
              <div className="flex gap-200 items-center justify-center px-300 py-300 w-full">
                <span className="text-text-brand-on-brand text-[16px] leading-none font-regular">Button</span>
              </div>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;

